import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AppBar,
  Box,
  Button,
  Grid,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import {
  appBarStyle,
  appToolBarStyle,
  headerLogin,
} from "components/header/HeaderStyle";
import { postLogout } from "redux/actions/authAction";
import { companyDetails } from "utils/companyDetails";
import { getBranding } from "config/tenantConfig";
import OfficeLogo from "assets/images/OfficeGrey.svg";
import UserLogo from "assets/images/UserLogo.svg";
import SignOutLogo from "assets/images/SignOutLogo.svg";
import { getProfile } from "redux/actions/ProfileAction";
import { fetchCompanyDetails } from "redux/actions/companyAction";

import { fetchCompanyLogo } from "redux/actions/companyAction";

const Header = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = useState();
  const isMenuOpen = Boolean(anchorEl);
  const Navigate = useNavigate();
  const companyID =
    localStorage.getItem("subCompany")?.length > 0 &&
    JSON.parse(localStorage.getItem("subCompany"));

  const [searchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams]);

  // useEffect(() => {
  //   if(token) {
  //     dispatch(getProfile());
  //   }
  // }, [])

  useEffect(() => {
    if (token) {
      dispatch(getProfile());

      if (companyID?.value) {
        // console.log("Selected Company ID:", companyID.value);

        dispatch(fetchCompanyDetails(companyID.value));
        dispatch(fetchCompanyLogo(companyID.value));
      }
    }
  }, []);

  const profile = useSelector(
    (state) => state?.userProfile?.profileDetails?.data,
  );

  const companyProfile = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails,
  );

  const logoDetails = useSelector(
    (state) => state?.userCompanyDetails?.logoDetails,
  );

  // console.log("Logo Details:", logoDetails);

  const handleMenuClose = () => {
    setAnchorEl(!anchorEl);
  };

  const handleOnclick = (val) => {
    if (val === "logout") {
      dispatch(postLogout());
    } else if (val === "login") {
      window.location.replace("/login");
    } else if (val === "companyProfile") {
      Navigate("/front-desk/companyDetails");
      setAnchorEl(!anchorEl);
    } else if (val === "myProfile") {
      Navigate("/front-desk/profileDetails", {
        state: { id: profile?.id, type: "edit", profile: true },
      });
      setAnchorEl(!anchorEl);
    }
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      open={isMenuOpen}
      onClose={handleMenuClose}
      className="custom-header-modal"
    >
      <MenuItem onClick={() => handleOnclick("companyProfile")}>
        <img src={OfficeLogo} alt="Office" />
        <Typography variant={"body2"} className="colorBlack pl10">
          Company Profile
        </Typography>
      </MenuItem>
      <MenuItem onClick={() => handleOnclick("myProfile")}>
        <img src={UserLogo} alt="Profile" />
        <Typography variant={"body2"} className="colorBlack pl10">
          My Profile
        </Typography>
      </MenuItem>

      <MenuItem onClick={() => handleOnclick("logout")}>
        <img src={SignOutLogo} alt="SignOut" />
        <Typography variant={"body2"} className="colorBlack pl10">
          Logout
        </Typography>
      </MenuItem>
    </Menu>
  );

  return (
    <Box>
      <AppBar position="static" style={appBarStyle}>
        <Toolbar style={appToolBarStyle}>
          <Grid container className={`height86 justifyBetween`}>
            {/* <Grid item>
              <img
                src={companyDetails?.companyLogo}
                className="width60"
                alt="logo"
              />
            </Grid> */}
            <Grid item>
              <img
                // src={
                //   companyProfile?.additionalInfo?.logoUrl ||
                //   companyDetails?.companyLogo
                // }
                src={
                  logoDetails?.logoUrl ||
                  companyProfile?.additionalInfo?.logoUrl ||
                  getBranding().logo ||
                  companyDetails?.companyLogo
                }
                className="width60"
                alt="logo"
              />
            </Grid>
            {token ? (
              <Box
                className="justifyEnd"
                role="presentation"
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <Typography variant={"body2"} className="fw600 pr10">
                  {companyID?.label || profile?.companyName || ""}
                </Typography>
                {anchorEl ? (
                  <KeyboardArrowUpRoundedIcon
                    role="presentation"
                    className="colorGrey img26"
                  />
                ) : (
                  <KeyboardArrowDownRoundedIcon
                    role="presentation"
                    className="colorGrey img26"
                  />
                )}
              </Box>
            ) : (
              params?.magicToken && (
                <>
                  <Button
                    size="medium"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    color="inherit"
                    style={headerLogin}
                    onClick={() => handleOnclick("login")}
                  >
                    Login
                  </Button>
                </>
              )
            )}
          </Grid>
        </Toolbar>
      </AppBar>
      {token && renderMenu}
    </Box>
  );
};

export default Header;
